import { useLayoutEffect, useRef, useState } from "react";
import { acquireOverlay } from "@/shared/lib/backBridge";

/**
 * 오버레이(팝업·시트·전체 화면)의 native back 계약 등록 — B2 결정 2026-10-27 "뒤로가기 = 배경 탭과 같게".
 *
 * - 등록 수명: 열린 순간부터 언마운트(닫힘 애니메이션 끝)까지. 닫히는 동안에도 등록돼 있어
 *   뒤로가기가 아래 화면(스텝 되감기 등)으로 새지 않는다. 닫히는 동안 무엇을 할지는 onBack 이 정한다(보통 소비만).
 * - 다시 열릴 때마다 스택 맨 위로 다시 올린다 — 닫히는 동안 다른 오버레이가 열린 뒤 이 오버레이가
 *   재사용되어 다시 열리면(전역 AlertDialogHost 등), 새로 열린 순서가 뒤로가기 순서에 반영되게.
 * - 등록·최신 콜백 반영은 layout effect 에서 — 화면에 반영되는 커밋과 같은 시점에 계약이 서게 한다.
 * - 등록 자체는 '보이는가'와 '열린 세대'에만 묶는다. onBack 이 바뀌어도 다시 등록하지 않아
 *   재렌더로 스택 순서가 바뀌지 않는다(최신 onBack 은 ref 로 읽음).
 *
 * @param isOpen 열림 상태(부모 prop)
 * @param isMounted 닫힘 애니메이션 동안에도 DOM 이 남아 있는지(없으면 isOpen 과 같은 값)
 * @param onBack 뒤로가기 처리 — 렌더 시점의 isOpen 을 읽어 닫히는 중이면 아무 일 없이 끝낸다
 */
export function useOverlayBackRegistration(
  isOpen: boolean,
  isMounted: boolean,
  onBack: () => void,
): void {
  // 열린 세대 — false→true 로 바뀔 때마다 1 증가(렌더 중 파생 상태 갱신 패턴).
  const [prevIsOpen, setPrevIsOpen] = useState(isOpen);
  const [openGeneration, setOpenGeneration] = useState(0);
  if (isOpen !== prevIsOpen) {
    setPrevIsOpen(isOpen);
    if (isOpen) setOpenGeneration((g) => g + 1);
  }

  const onBackRef = useRef(onBack);
  useLayoutEffect(() => {
    onBackRef.current = onBack;
  });

  const isActive = isOpen || isMounted;
  useLayoutEffect(() => {
    if (!isActive) return;
    return acquireOverlay(() => onBackRef.current());
  }, [isActive, openGeneration]);
}
